import { useEffect } from "react"
import { Logger } from "shared/Helpers/logging"
import { useAppNavigation } from "shared/hooks/useAppNavigation"
import { useFirebaseMessaging } from "shared/Modules/Cordova/hooks/useFirebase"

/**
 * iOS 12+: the app's notification settings in iOS settings get an in-app settings button (enabled by
 * requesting permission with `providesAppNotificationSettings`, see useFirebase). Tapping it opens the
 * app and fires the plugin's onOpenSettings callback; we send the user to Me > Settings > Push notifications.
 */
export function useNotificationSettingsShortcut() {
    const firebase = useFirebaseMessaging()
    const { goToPushNotificationSettings } = useAppNavigation()
    const logger = new Logger("notifications")

    useEffect(() => {
        if (!firebase) return

        logger.info("Registering handler for iOS notification settings shortcut")
        firebase.onOpenSettings(
            () => {
                logger.info("Opened from iOS notification settings [navigating to push notification settings]")
                goToPushNotificationSettings()
            },
            (error) => logger.warn("Failed to register notification settings shortcut", error),
        )
    }, [firebase])
}
